import React, {useRef, useState} from 'react'
import TableHeader from '../../../../components/table/TableHeader'
import Text from '../../../../components/text/Text'
import TableLayout from '../../../../components/table/TableLayout'
import TableItem from '../../../../components/table/TableItem'
import WizImage from '../../../../components/image/WizImage'
import {useImage} from '../../../../utils/image'
import {useTime} from '../../../../utils/time'
import useNavigation from '../../../../hooks/useNavigation'
import {IRecommend} from '../../../../apis/recommend/getRecommend'
import WizButton from '../../../../components/button/WizButton'
import UnderLineInput from '../../../../components/input/UnderLineInput'
import {editRecommendRankApi} from '../../../../apis/recommend/editRecommendRankApi'
import DeleteRecommendModal from './DeleteRecommendModal'

interface IProps {
    className?: string
    data?: IRecommend[]
}

const RecommendTable: React.FC<IProps> = ({className, data}) => {
    const {renderThumbnail} = useImage()
    const {localTimeString} = useTime()
    const {goPostDetail} = useNavigation()

    const [rank, setRank] = useState()

    const deleteRecommendModalRef = useRef<any>()

    const onClickRankChange = async id => {
        await editRecommendRankApi(id, rank).then(res => {
            if (!res.error) {
                alert('Changed Rank Complete')
                window.location.reload()
            } else {
                alert('Changed Rank Error')
            }
        })
    }

    const checkLotWriterColor = name => {
        if (name === 'League of Traders') {
            return 'text-font_green'
        } else if (name === 'League of Traders EN') {
            return 'text-sub_blue'
        }
    }

    return (
        <div className={`${className}`}>
            <TableHeader className={'grid-cols-[220px_1fr_190px_140px_110px] md:hidden'}>
                <Text>Writer</Text>
                <Text>Title</Text>
                <Text>Create At</Text>
                <Text>Rank</Text>
                <div></div>
            </TableHeader>
            <TableLayout>
                {data?.map(list => (
                    <>
                        <TableItem
                            key={list?.id}
                            className={'grid-cols-[220px_1fr_190px_140px_110px] gap-x-[10px] md:block md:text-center'}>
                            <div className={'flex space-x-[10px] items-center md:justify-center'}>
                                <WizImage
                                    src={renderThumbnail(list?.user.thumbnail)}
                                    className={'w-[36px] h-[36px] rounded-full md:w-[30px] md:h-[30px]'}
                                />
                                <Text className={`text-ti2 ${checkLotWriterColor(list?.user.name)}`}>
                                    {list?.user.name}
                                </Text>
                            </div>
                            <div className={'truncate md:mt-[20px]'}>
                                <Text
                                    className={'text-ti2 hover:text-primary truncate md:text-h4 md:px-[20px]'}
                                    onClick={() => goPostDetail(list?.id)}>
                                    {list?.title}
                                </Text>
                            </div>
                            <div className={'md:mt-[5px]'}>
                                <Text className={'text-body2 text-font02 md:text-font03'}>
                                    {localTimeString(list?.created_at)}
                                </Text>
                            </div>
                            <div
                                className={
                                    'flex items-center space-x-[10px] md:mt-[30px] md:justify-center sm:w-[60%] sm:mx-auto'
                                }>
                                <UnderLineInput
                                    value={list?.rank}
                                    onChanged={(e: any) => {
                                        setRank(e)
                                    }}
                                    inputClassName={'text-center '}
                                />
                                <WizButton
                                    text={'Change'}
                                    type={'blue'}
                                    size={'small'}
                                    onClick={() => onClickRankChange(list?.id)}
                                />
                            </div>

                            <div className={'text-right md:text-center md:mt-[20px]'}>
                                <WizButton
                                    text={'Remove'}
                                    type={'red'}
                                    size={'small'}
                                    onClick={() => deleteRecommendModalRef?.current?.show(list?.id)}
                                />
                            </div>
                            <DeleteRecommendModal ref={deleteRecommendModalRef} />
                        </TableItem>
                    </>
                ))}

                {!data?.length && (
                    <TableItem className={'text-center'}>
                        <div>
                            <Text>No Items</Text>
                        </div>
                    </TableItem>
                )}
            </TableLayout>
        </div>
    )
}

export default RecommendTable
